import type { MediaDto } from '@shelflix/trpc/routes/media/list/useCase';
import { Card } from '@shelflix/ui-web/components/ui/card';
import { Checkbox } from '@shelflix/ui-web/components/ui/checkbox';
import { MediaCardVertical } from '../MediaCardVertical';

interface SelectMediaCardProps {
  media: MediaDto;
  brandName: string;
  isSelected: boolean;
  onToggle: (media: MediaDto, checked: boolean) => void;
}

export function SelectMediaCard({ media, brandName, isSelected, onToggle }: SelectMediaCardProps) {
  return (
    <Card className="bg-background gap-0 overflow-hidden rounded-[10px] py-0">
      <div className="relative w-full overflow-hidden rounded-[4px]">
        <div className="absolute top-2 right-2 z-800">
          <Checkbox className="" checked={isSelected} onCheckedChange={(checked) => onToggle(media, !!checked)} />
        </div>

        <MediaCardVertical
          media={media}
          brandName={brandName}
          onPlay={() => {}}
          onInfo={() => {
            onToggle(media, !isSelected);
          }}
        />
      </div>
    </Card>
  );
}
